import { Component, OnInit, OnDestroy } from '@angular/core';
import {Location} from "@angular/common";
import {Authorization} from "../shared/authorization/index";
import { Router, ActivatedRoute,NavigationEnd} from '@angular/router';
import {Subscriber} from "rxjs";
import { Subscription } from 'rxjs';
// Avoid name not found warnings
declare var PDFJS: any;

/**
 * This class represents the lazy loaded HomeComponent.
 */
@Component({
    selector: 'sd-home',
    providers: [],
    templateUrl: 'home.component.html',
    styleUrls: ['home.component.css'],
    standalone: false
})

export class HomeComponent implements  OnDestroy, OnInit{

  newName: string = '';
  errorMessage: string;
  names: any[] = [];
  routerEventSubscription: Subscription;
  redirected: boolean=false;



  /**
   * Creates an instance of the HomeComponent with the injected
   * NameListService.
   *
   * @param {NameListService} nameListService - The injected NameListService.
   */
  constructor( private authorization:Authorization,
               private router: Router,
               private location: Location
              ) {

    let _this = this;
    this.routerEventSubscription = this.router.events.subscribe(function (routerEvent) {
      if (routerEvent instanceof NavigationEnd) {
        if (routerEvent.urlAfterRedirects.startsWith("/#access")) {
            //parse hash
          _this.authorization.parseHash();
          //wait for login process to finish
          _this.authorization.initialized$.subscribe(
            (isInitialized : boolean) => {
              if(isInitialized){
                _this.location.replaceState('/docs');
                _this.router.navigate(['/docs']);
              }
            }
          );
          //TODO: logging in or init animation

         }
         else  if (routerEvent.urlAfterRedirects.startsWith("/")) {
          {
            if (_this.authorization.authenticated()){
              //authenticated and login initialization finished
              if ( _this.authorization.isInitializedAfterLogin()) {

                _this.location.replaceState('/docs');
                _this.router.navigate(['/docs']);

              }
              else{ //authenticated but initialization not finished
                console.log("Unexpected login step");
                _this.authorization.logout();

              }
            }
            else {
              _this.routerEventSubscription.unsubscribe();
            }

          }

        }
      }


    });
  }

  ngOnInit(){

  }
    ngOnDestroy() {
     this.routerEventSubscription.unsubscribe();
    }
//http://localhost:5555/#access_token=2PP6ePu1t7TfG5GC&expires_in=86400&id_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6IlJVVkJPRU5FTXpGQk1UVXlPVUkyUmpRek5rTTJRamxCUVRBNE5URTJSa0k0UmpVM1EwRkJRdyJ9.eyJpc3MiOiJodHRwczovL2lsZXJpZGV2LmF1dGgwLmNvbS8iLCJzdWIiOiJhdXRoMHw1ODcyNDFlNWI5NGE0ZDc3YzFmOTU3ODQiLCJhdWQiOiI1RmthS29XZG56QksyZ3VUbWlHRURFOEdKYThHTHZWZSIsImV4cCI6MTQ5MDMzODg2OSwiaWF0IjoxNDkwMzAyODY5fQ.C6sDf3Iid5xHsgtYpcv53ydgHuzCKRU6xAtlfXYRgQagICWKG-0TnNnSURYRG6_S4VN0GkL16xUJlcJh4dfAnCQRr3yz8OpdkVQhIwW00dLSpHykcumLwxhu-4tOqnkHpNd7SMa0MRqmJcBryg_CdFWhpW_tjRXNMFwp9nLHwz2cGnZgD4E5zOsnMmWkIL90KaqbqWW5g-iXsdmunttbUyKlGo9dy8X53J0Ln1PRt-sHxsibuJedf5Z54inHgEebH5lMwKZvrmuHnBl6nl98SKrMJ5pDY_Cr0WbjVx3E75b0oEqUPN_w3QofyLBDo_IKbvCVri2Pj6x9JKSy9IWOIg&token_type=Bearer



}
